import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Config } from './config';
import { Size } from '../Models/size';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class SizeService {

  constructor(
    private http: HttpClient,
    private config: Config,
    private languageService: LanguageService) { }

  /**
   * Allow filtering on category.
   */
  list(categories?: Array<number>): Observable<Size[]> {

    var params = new HttpParams();

    if (categories) {

      for (var i= 0; i < categories.length; i++) {
        params = params.append('category', "" + categories[i]);
      }
    }

    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<Size[]>(
          this.config.getURL('sizes'),
          { params: params }
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/size.ts